/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {Component, h} from 'preact';
import {PropTypes} from 'preact-compat';
import styles from './styles/NoSignalScreen.css';

export class NoSignalScreen extends Component {
  render() {
    const mediaUri = this.props.mediaUri || '';

    if (!mediaUri) {
      return (
        <div className={styles.container}>
          <div className={styles.centerColumn}>
            <div className={styles.noSignal} title={this.props.message || 'Offline'}/>
          </div>
        </div>
      );
    }

    const isVideo = mediaUri.includes('mp4');

    if (isVideo) {
      return (
        <div className={styles.container}>
          <div className={styles.centerColumn}>
            <video className={styles.noSignal} src={mediaUri} autoPlay loop muted></video>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <div className={styles.centerColumn}>
          <img className={styles.noSignal} src={mediaUri} alt={this.props.message || 'Offline'}></img>
        </div>
      </div>
    );
  }
}

NoSignalScreen.propTypes = {
  mediaUri: PropTypes.string,
  message: PropTypes.string
};

export default NoSignalScreen;